import { createSlice } from "@reduxjs/toolkit";
import { CatalogInitialStore } from "./types.store";
// eslint-disable-next-line import/no-cycle
import {
  handleGetCatalogAreaRequest,
  handleGetCatalogBrandsRequest,
  handleGetCatalogCategoriesRequest,
  handleGetCatalogProductsRequest,
} from "./thunk.store";

const initialState: CatalogInitialStore = {
  coverageArea: null,
  catalogProducts: null,
  catalogBrands: null,
  catalogCategories: null,
};

const CatalogStore = createSlice({
  initialState,
  name: "CatalogData",
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(handleGetCatalogAreaRequest.fulfilled, (state, action) => {
      if (!action.payload.data) {
        // state.coverageArea = [];
        return;
      }

      const coverageArea = (state.coverageArea || []).filter(
        (area) =>
          area.coverageAreaId !== action.payload.data.coverageAreaId || "",
      );
      state.coverageArea = coverageArea.concat(action.payload.data) || [];
    });

    builder.addCase(
      handleGetCatalogProductsRequest.fulfilled,
      (state, action) => {
        state.catalogProducts = action.payload;
      },
    );
    builder.addCase(
      handleGetCatalogCategoriesRequest.fulfilled,
      (state, action) => {
        state.catalogCategories = action.payload;
      },
    );
    builder.addCase(
      handleGetCatalogBrandsRequest.fulfilled,
      (state, action) => {
        state.catalogBrands = action.payload;
      },
    );
  },
});

export default CatalogStore.reducer;
